module.exports = __webpack_public_path__ + "img/vue2-lacet_noir.7777a1c1.png";